<div class="row">
    <div class="col-xl-12">
        <div class="card card-box mb-3">
            <div class="card-header">
                <div class="card-header--title">
                    <h3 class="font-size-lg mb-0 py-2 font-weight-bold">
                        Accounts Receivable (AR) Dashboard
                    </h3>
                </div>
                <div class="card-header--actions">
                    <div class="btn-group btn-group-sm" dropdown>
                        <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-primary" dropdownToggle
                            type="button">
                            {{filterSelection}}
                            <fa-icon [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1"></fa-icon>
                        </button>
                        <div *dropdownMenu class="dropdown-menu dropdown-menu-xl dropdown-menu-right">
                            <ul class="nav nav-neutral-dark nav-pills flex-column px-3">
                                <li class="nav-item nav-item--header px-0">
                                    <span class="text-capitalize text-black font-size-md font-weight-bold">Select
                                        Time Period</span>
                                </li>
                                <li class="dropdown-divider"></li>
                                <li class="nav-item">
                                    <a (click)='currentYear()' class="nav-link">
                                        <span>Current Year</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a (click)='previousYear()' class="nav-link">
                                        <span>Previous Year</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <button tooltip="Refresh" (click)='currentYear()'
                    class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                    type="button">
                    <span class="btn-wrapper--icon">
                        <i class="ion-md-sync"></i>
                    </span>
                </button>
            </div>
            <div class="card-body pb-1 font-weight-bold">
                <div class="row">
                    <div class="col-xl-12">
                <h6 class="m-2 font-weight-bold ">
                                        Fiscal Year Open/Closed Transactions
                                    </h6>
                                <div class="row">
                                    <div class="col-xl-6 col-md-6 col-sm-12" >
                                        <h6  class="pl-2 pt-2 m-2"*ngIf="pieChartData?.length == 0">USA: No Data</h6>
                                       
                                        <div class="d-block" *ngIf="pieChartData?.length>0"
                                         style="border: 1px solid #4c86a0;
                                            margin: 10px;
                                            padding-bottom: 10px;">
                                             <h5 style="text-align: center;
                                             background: #ebeaea;
                                             padding: 10px;"> USA </h5>
                                            <canvas baseChart [data]="pieChartData" [labels]="pieChartLabels" [colors]="pieChartColors"
                                                [chartType]="pieChartType" [options]="pieChartOptions" [plugins]="pieChartPlugins"
                                                [legend]="pieChartLegend" id="summaryPieChart">
                                            </canvas>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-md-6 col-sm-12">
                                        <h6   class="pl-2 pt-2 m-2" *ngIf="pieChartDataCA?.length == 0">CANADA: No Data</h6>
                                        <div class="d-block" *ngIf="pieChartDataCA?.length>0"  style="border: 1px solid #4c86a0;
                                            margin: 10px;
                                            padding-bottom: 10px;">
                                          
                                               <h5 style="text-align: center;
                                               background: #ebeaea;
                                               padding: 10px;"> CANADA </h5>
                                            <canvas baseChart [data]="pieChartDataCA" [labels]="pieChartLabels" [colors]="pieChartColors"
                                                [chartType]="pieChartType" [options]="pieChartOptions" [plugins]="pieChartPlugins"
                                                [legend]="pieChartLegend" id="summaryPieChart">
                                            </canvas>
                                        </div>
                                    </div>

                                    <!-- <div class="col-xl-6 col-md-6 col-sm-12">
                                        <h6 *ngIf="pieChartDataNUM?.length == 0">No Data</h6>
                                        <div class="d-block" *ngIf="pieChartDataNUM.length>0"  style="border: 1px solid #4c86a0;
                                            margin: 10px;
                                            padding-bottom: 10px;">
                                          
                                               <h5 style="text-align: center;
                                               background: #ebeaea;
                                               padding: 10px;"> CANADA </h5>
                                            <canvas baseChart [data]="pieChartDataNUM" [labels]="pieChartLabels" [colors]="pieChartColors"
                                                [chartType]="pieChartType" [options]="pieChartOptions" [plugins]="pieChartPlugins"
                                                [legend]="pieChartLegend" id="summaryPieChart">
                                            </canvas>
                                        </div>
                                    </div> -->
                                </div>
                    </div>
                </div>
                <div class="row" *ngIf="pendingPaymentTypeTransactionsData?.length>0">
                    <div class="col-xl-12">
                        <div *ngIf="pendingPaymentTypeTransactionsData; let latest">
                            <h6 class="m-2 font-weight-bold ">
                                Payment Type Pending Transactions
                            </h6>
                            <div class="table-responsive">
                                <perfect-scrollbar [autoPropagation]="true" class="scroll-area mb-2">
                                    <table class="table table-hover text-nowrap table-bordered mb-0">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col">TOTAL #</th> 
                                                <th scope="col">STATION</th>
                                                <th scope="col">CURRENCY</th>
                                                <th scope="col">TOTAL $</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let g of pendingPaymentTypeTransactionsData let i=index;">
                                                <td>{{g?.TOTAL_NUMBERS}}</td>
                                                <td>{{g.STATION}}</td>
                                                <td>{{g.CURRENCY_FLAG}}</td>
                                                <td>{{g.TOTAL_AMOUNT}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </perfect-scrollbar>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-6"  *ngIf="dueTransactionsData?.length>0">
                        <div *ngIf="dueTransactionsData; let latest">
                            <h6 class="m-2 font-weight-bold ">
                                Past Due Invoices
                            </h6>
                            <div class="table-responsive">
                                <perfect-scrollbar [autoPropagation]="true" class="scroll-area mb-2">
                                    <table class="table table-hover text-nowrap table-bordered mb-0">
                                        <thead class="thead-light">
                                            <tr>
                                                 <th scope="col">NET TERMS</th> 
                                                <th scope="col">TOTAL</th>
                                                <th scope="col">CURRENCY</th>
                                            </tr>
                                        </thead>
        
                                        <tbody>
        
                                            <tr *ngFor="let g of dueTransactionsData let i=index;">
                                             
                                                <td>{{g?.NET_TERMS}}</td>
                                                <td>{{g.TOTAL_AMOUNT}}</td>
                                                <td>{{g.CURRENCY_FLAG}}</td>
                                            </tr>
        
                                        </tbody>
                                    </table>
                                </perfect-scrollbar>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6"  *ngIf="unPaidTransactionsData?.length>0">
                        <div class="table-responsive">
                            <h6 class="m-2 font-weight-bold ">
                                UnPaid Transactions
                            </h6>
                            <perfect-scrollbar [autoPropagation]="true" class="scroll-area scroll-area mb-2">
                                <table class="table table-hover text-nowrap table-bordered mb-0">
                                    <thead class="thead-light">
                                        <tr>
                                         
                                            <th scope="col">TOTAL#</th>
                                            <th scope="col">CURRENCY</th>
                                            <th scope="col">TOTAL $</th>
                                            <th scope="col">Payment TYPE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor='let transaction of unPaidTransactionsData'>
                                          
                                            <td>{{transaction?.TOTAL_NUMBERS}}</td>
                                            <td>{{transaction?.CURRENCY_FLAG}}</td>
                                            <td>{{transaction?.TOTAL_AMOUNT}}</td>
                                            <td>{{transaction?.TRANSACTION_TYPE}}</td>
                
                                        </tr>
                                    </tbody>
                                </table>
                            </perfect-scrollbar>
                        </div>
                    </div> 
                </div>
                <div class="row">
                    <div class="col-xl-6"  *ngIf="summaryReservations?.length>0">
                        <div *ngIf="summaryReservations; let k">
                            <h6 class="m-2 font-weight-bold ">
                               Paid Reservations Count
                            </h6>
                            <div class="table-responsive">
                                <perfect-scrollbar [autoPropagation]="true" class="scroll-area mb-2">
                                    <table class="table table-hover text-nowrap table-bordered mb-0">
                                        <thead class="thead-light">
                                            <tr>
                                                 <th scope="col">Total Numbers</th> 
                                                <th scope="col">Amount</th>
                                                <th scope="col">Country</th>
                                            </tr>
                                        </thead>
        
                                        <tbody>
        
                                            <tr *ngFor="let pnm of summaryReservations let i=index;">
                                             
                                                <td>{{pnm?.TOTAL_NUMBERS}}</td>
                                                <td>{{pnm?.TOTAL_AMOUNT}}</td>
                                                <td>{{pnm?.CURRENCY_FLAG}}</td>
                                            </tr>
        
                                        </tbody>
                                    </table>
                                </perfect-scrollbar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

